import React from "react";
import Typography from "@material-ui/core/Typography";
import * as APIStore from "../../store/APIStore";
import DiagnosisCodeHcc from './DiagnosisCodeHcc'
import Grid from "@material-ui/core/Grid";
import DateDisplay from '../common/DateDisplay'
import {formatDate} from '../common/DateHelper'

export interface PatientDischargeDisplayProps {
    encounter: APIStore.Encounter,

}


const PatientDischargeDisplay = (props : PatientDischargeDisplayProps) => {
    let {encounter} = props;
    if(encounter.encounterEnd) {
        return (<React.Fragment>
            <Grid item>
            <DateDisplay
                                    DateValue={formatDate(encounter.encounterEnd, false)}
                                    DateNullText="NOT DISCHARGED"
                                    Label="Discharged"
                                />


                           </Grid>
       </React.Fragment>)
    }

    let {daysUntilDischarge} = encounter;
    if(daysUntilDischarge > 10000) { // TODO error codes
        return (<React.Fragment>
            <Grid item>
                               <Typography variant="body1" component="div" gutterBottom>
                               <strong>Days to Discharge:{" "}</strong>
                                   <Typography variant="body2" component="span" gutterBottom="100">
                                       N/A
                                   </Typography>
                               </Typography>
                           </Grid>
       </React.Fragment>)
    }
    return (<React.Fragment>
         <Grid item>
                            <Typography variant="body1" component="div" gutterBottom>
                            <strong>Days to Discharge:{" "}</strong>
                                <Typography variant="body2" component="span" gutterBottom="100">
                                    {daysUntilDischarge}
                                </Typography>
                            </Typography>
                        </Grid>
    </React.Fragment>)
}

export default PatientDischargeDisplay
